import React from 'react';
import {useTheme} from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {IDialogProps} from "./types";
import {PrimaryButton, SecondaryButton} from "../form";


export const DialogBox: React.FC<IDialogProps> = (
    {
        isOpen = false,
        onClose,
        title = "",
        message = "",
    }: IDialogProps
) => {
    const theme = useTheme();

    const handleClose = () => {
        onClose("cancel");
    }

    const handleOk = () => {
        onClose("ok");
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="dialog-box-title"
            aria-describedby="dialog-box-description"
        >
            <DialogTitle
                id="dialog-box-title"
                sx={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "start"
                }}
            >
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="dialog-box-description">
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <SecondaryButton variant={"outlined"} autoFocus onClick={handleClose}>Cancel</SecondaryButton>
                <PrimaryButton variant={"outlined"} onClick={handleOk}>OK</PrimaryButton>
        </DialogActions>
      </Dialog>
    );
}